export const SIZES = {
  SMALL: 0.150, // vw (used to be 240px)
  THREE_QUARTERS: 0.157,
  LARGE: 0.20 // vw (used to be 360px)
}
